import { useChurchStore } from "features/churches";
import { useParams } from "react-router-dom";
import { useSendMessages } from "../api";
import { ChatPanel, MessageList, ScheduledMessagesPanel } from "../components";
import { useStoredMessagesStore } from "../store";

export const ScheduledMessages = () => {
  const { id } = useParams();
  const selectedChurch = useChurchStore(state => state.selectedChurch);
  const storedMessages = useStoredMessagesStore(state => state.storedMessages);
  const storeMessages = useStoredMessagesStore(state => state.storeMessages);
  const scheduledQuery = useSendMessages({
    churchId: selectedChurch?.id,
    filters: ["filters[is_scheduled]=1", "sort[created_at]=DESC"]
  });

  if (id) {
    storeMessages(scheduledQuery?.data?.result);

    return (
      <>
        <MessageList title="Scheduled Messages" messages={storedMessages} />
        <ChatPanel />
      </>
    );
  }

  return <ScheduledMessagesPanel />;
};
